// API: https://ant.design/components/table/
// Common Table component that contains common formatting and configuration data.
// But also is a passthrough for the standards Ant Design table (see API).
import { Table } from 'antd';
import Tables from './TableConfigs';
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';

const { getDataType } = ssCommonUtils;

export default class extends React.Component {
    constructor(props) { super(props); }
    render = () => {
        const { disableConfiguration, configuration } = this.props;
        return disableConfiguration ? <Table {...this.props} /> : (() => {
            if (configuration == null || getDataType(configuration) !== 'String') return <Tables.DefaultTable {...this.props} />;
            else switch(configuration) {
                case 'default': return <Tables.DefaultTable {...this.props} />;
                default: return <Tables.DefaultTable {...this.props} />;
            }
        })()
    };
}